import {ImSystemDto} from "../../../../../../../feature-integration/im/model/dto/entity/im-system.dto";


export class UiCustomerExternalAlias {
    systemDto: ImSystemDto;
    systemDtoId: number;
    uiAliasList: string[];
}
